import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  FiUser,
  FiCalendar,
  FiChevronRight,
  FiHome,
  FiDollarSign,
} from "react-icons/fi";

import { getMySupportIncome } from "../../store/slices/fund";

const SupportIncome = () => {
  const dispatch = useDispatch();

  /* =====================================================
     REDUX
  ===================================================== */

  const {
    supportIncome,
    supportIncomeLoading,
    supportIncomeError,
  } = useSelector((state) => state.fund);

  /* =====================================================
     GET SUPPORT INCOME
  ===================================================== */

  useEffect(() => {
    dispatch(getMySupportIncome());
  }, [dispatch]);

  /* =====================================================
     DATA
  ===================================================== */

  const incomes = Array.isArray(supportIncome?.records)
    ? supportIncome.records
    : [];

  const totalAmount =
    Number(supportIncome?.totalAmount) || 0;

  /* =====================================================
     FORMAT DATE
  ===================================================== */

  const formatDate = (date) => {
    if (!date) {
      return "-";
    }

    const parsedDate = new Date(date);

    if (Number.isNaN(parsedDate.getTime())) {
      return "-";
    }

    return parsedDate.toLocaleString("en-IN", {
      dateStyle: "medium",
      timeStyle: "short",
    });
  };

  /* =====================================================
     FORMAT AMOUNT
  ===================================================== */

  const formatAmount = (amount) => {
    return Number(amount || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  };

  /* =====================================================
     RETURN
  ===================================================== */

  return (
    <div className="gi-referral-page">

      {/* ================= BREADCRUMB ================= */}

      <div className="gi-breadcrumb">

        <Link to="/dashboard">
          <FiHome />
          Dashboard
        </Link>

        <FiChevronRight className="gi-breadcrumb-arrow" />

        <span>
          Income Report
        </span>
        <FiChevronRight className="gi-breadcrumb-arrow" />

        <span>
          Support Income
        </span>

      </div>

      {/* ================= TABLE CARD ================= */}

      <section className="gi-referral-table-card">


        <div className="gi-referral-table-wrapper">

          <table className="gi-referral-table">

            <thead>

              <tr>

                <th>
                  #
                </th>
                <th>

                  Support Amount
                </th>

                <th>
                  Added By
                </th>

                <th>
                  Date
                </th>

                <th>
                  Remarks
                </th>

              </tr>

            </thead>

            <tbody>
              {supportIncomeLoading && (
                <tr>

                  <td
                    colSpan="6"
                    className="gi-table-message"
                  >
                    Loading support income...
                  </td>

                </tr>
              )}

              {!supportIncomeLoading &&
                supportIncomeError && (

                  <tr>

                    <td
                      colSpan="6"
                      className="gi-table-message"
                    >
                      {supportIncomeError}
                    </td>

                  </tr>
                )}

              {!supportIncomeLoading &&
                !supportIncomeError &&
                incomes.length === 0 && (
                  <tr>
                    <td
                      colSpan="5"
                      className="gi-table-message text-center"
                    >
                      No support income found!
                    </td>
                  </tr>
                )}


              {!supportIncomeLoading &&
                !supportIncomeError &&
                incomes.map((item, index) => (

                  <tr
                    key={
                      item?._id || index
                    }
                  >

                    {/* NUMBER */}

                    <td className="gi-referral-number">

                      {String(index + 1).padStart(
                        2,
                        "0"
                      )}

                    </td>

                    {/* USER ID */}


                    {/* SUPPORT AMOUNT */}

                    <td>

                      <strong className="gi-income-amount">

                        $
                        {formatAmount(
                          item?.amount
                        )}

                      </strong>

                    </td>

                    {/* ADDED BY */}

                    <td>

                      <div className="gi-user-cell">

                        <div className="gi-user-avatar">

                          {item?.addedByName
                            ?.charAt(0)
                            ?.toUpperCase() || "U"}

                        </div>

                        <div>

                          <strong>

                            {item?.addedByName ||
                              "-"}

                          </strong>

                        </div>

                      </div>

                    </td>

                    {/* DATE */}

                    <td>

                      <span className="gi-date-text">

                        {formatDate(
                          item?.createdAt
                        )}

                      </span>

                    </td>

                    {/* REMARKS */}

                    <td>

                      <span className="gi-income-type">

                        {item?.remarks || "-"}

                      </span>

                    </td>

                  </tr>

                ))}

            </tbody>

          </table>

        </div>

      </section>

    </div>
  );
};

export default SupportIncome;